import { AuthenticationService } from './core/services/authentication.service';
import { environment } from 'src/environments/environment';
import {
  Component,
  HostListener,
  OnInit,
  Inject,
  OnDestroy,
} from '@angular/core';
import { Subscription } from 'rxjs';
declare const window: Window & { onUsersnapCXLoad?: (api: any) => void };

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'frontend';
  private script: HTMLScriptElement | null = null;
  public usersnapApi: any | null = null;
  emailid = '';
  userNotificationSubscription: Subscription;

  constructor(public auth: AuthenticationService) {
    this.initializeUserSnap();
  }

  ngOnInit(): void {
    this.userNotificationSubscription = this.auth.headerDetail.subscribe(
      (value) => {
        this.usersnapApi?.destroy();
        this.script?.remove();
        this.initializeUserSnap();
      }
    );
  }
  initializeUserSnap() {
    return new Promise<any>((resolve) => {
      window.onUsersnapCXLoad = (api: any) => {
        api.init({
          user: {
            email: this.auth.getUserEmailId(),
          },
        });
        this.usersnapApi = api;
        resolve(api);
      };
      this.script = document.createElement('script');
      this.script.defer = false;
      this.script.type = 'text/javascript';
      this.script.src = `https://widget.usersnap.com/global/load/${environment.usersnapGlobal}?onload=onUsersnapCXLoad`;
      document.body.appendChild(this.script);
    });
  }

  // private handleOpenWidget = (event: any) => {
  //   event.api.setValue('email', this.auth.getUserEmailId());
  //   console.log('this.auth.getUserEmailId()');
  //   console.log(this.auth.getUserEmailId());
  // };
  // constructor() {
  //   this.loadScript();
  // }
  // public loadScript() {
  //   console.log('preparing to load...');

  //   const node = document.createElement('script');
  //   node.src =
  //     'https://widget.usersnap.com/global/load/b5fb2517-7823-4e00-9202-4389438606e7?onload=onUsersnapCXLoad';
  //   node.type = 'text/javascript';
  //   node.async = true;
  //   node.charset = 'utf-8';
  //   document.getElementsByTagName('head')[0].appendChild(node);

  //   api.init({
  //     mountNode: document.getElementById('widgetContainer')
  //     locale: 'de',
  //   });
  // }

  ngOnDestroy() {
    if (this.usersnapApi) {
      this.usersnapApi?.destroy();
    }
    this.script?.remove();
    this.userNotificationSubscription?.unsubscribe();
  }
}
